// cleanup_convert_to_typescript_file_CONTACTCNTR

export default {
  'payeeImport.upload.uploading': 'Uploading',
  'payeeImport.viewDetails.sampleFile': 'Sample File',
  'payeeImport.viewDetails.countryCodeList': 'Country Code List',
  'payeeImport.viewDetails.fieldPosition': 'Field Position',
  'payeeImport.viewDetails.fieldName': 'Field Name',
  'payeeImport.viewDetails.requiredField': 'Required Field',
  'payeeImport.upload.title': 'Import Payee File',
  'payeeImport.upload.invalidFile': '<%- filename %> is an invalid file type',
  'payeeImport.upload.invalidCSV': 'Please add a valid .csv file',
  'payeeImport.map.countryList': 'Complete country code list available to download above.'
};
